import { AxiosForLegacyBackend } from "../../utils/helpers/AxiosForLegacyBackend";

export const fetchSendEmail = async (): Promise<void> => {
  await AxiosForLegacyBackend({
    url: "/email/callback?isCDM=false",
    method: "POST"
  });
};
